import { render, staticRenderFns } from "./Recuperacion.vue?vue&type=template&id=d49aeb24"
import script from "./Recuperacion.vue?vue&type=script&lang=js"
export * from "./Recuperacion.vue?vue&type=script&lang=js"
import style0 from "./Recuperacion.vue?vue&type=style&index=0&id=d49aeb24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports